<template>
  <div class="o-card u-padding-xsmall u-display-flex">
    <Button
      @click="battery.isPermission && (lockedModal.status = true)"
      :disabled="!battery.isPermission"
      class="u-margin-right-xsmall"
      block
      :variant="battery.isLocked ? 'light-danger' : 'light-success'"
    >
      <i :class="`icofont-ui-${battery.isLocked ? '' : 'un'}lock`"></i>
      {{
        battery.isLocked ? $t("common.lockedText") : $t("common.unlockedText")
      }}
    </Button>
    <router-link
      class="u-width-100% u-margin-right-xsmall"
      :to="`/batteries/${battery.id}/copy`"
    >
      <Button block variant="light-primary">
        {{ $t("common.copy") }}
      </Button>
    </router-link>
    <Button
      :disabled="!battery.isPermission || battery.isLocked"
      @click="
        (battery.isPermission || battery.isLocked) &&
          (removeModal.status = true)
      "
      block
      variant="light-danger"
    >
      <i
        :class="`icofont-${
          battery.isPermission && !battery.isLocked ? 'trash' : 'ui-lock'
        } u-margin-right-xsmall`"
      ></i>
      {{ $t("common.remove") }}
    </Button>
    <LockedModal
      v-model="lockedModal.status"
      :description="$t(`updateBatteries.${SET_LOCKED_DESCRIPTION()}`)"
      :okText="$t(`common.${SET_LOCKED_DESCRIPTION()}`)"
      @ok="LOCKED_ITEM"
    ></LockedModal>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
  </div>
</template>

<script>
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import LockedModal from "@/components/Shared/LockedModal/index.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
export default {
  name: "ActionBar",
  components: {
    Button,
    LockedModal,
    RemoveModal,
  },
  data() {
    return {
      lockedModal: {
        status: false,
      },
      removeModal: {
        status: false,
      },
    };
  },
  props: {
    battery: {
      default: () => ({}),
    },
  },
  methods: {
    SET_LOCKED_DESCRIPTION() {
      return this.battery.isLocked ? "unlocked" : "locked";
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await this.$store.dispatch("removeBattery", {
        id: this.battery.id,
      });
      if (response.message === "OK") {
        this.$router.push({ name: "batteries" });
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`removeBatteries.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`removeBatteries.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async LOCKED_ITEM(loading) {
      loading(true);
      const response = await Requests.Battery.UpdateLockStatus(
        { params: { id: this.battery.id } },
        { isLocked: !this.battery.isLocked }
      );
      if (response.message === "OK") {
        this.$emit("refresh");
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateBatteries.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateBatteries.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
};
</script>

<style></style>
